export default __webpack_public_path__ + "static/media/boy-face.c3079bc4.png";